import { Component } from "react";
import Styles, { Colors } from "../Styles";

export default class Header extends Component {
    render() {
        return <h1 className="header-h1" style={{
            ...this.props.style
        }}>{this.props.children}</h1>
    }
}